module.exports = __webpack_public_path__ + "img/Myo.1c2f8710.png";